exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-public-dashboard {\n  display: block; }\n\n.group-actions a {\n  margin-left: 5px; }\n\n.pd-action {\n  float: left; }\n\n.pd-action .action-icon-menu {\n  padding-left: 12px; }\n\n.pd-action .action-icon-menu i.fi {\n    font-size: 14px;\n    vertical-align: -webkit-baseline-middle; }\n\n.mat-menu-panel.pd-menu-container button.mat-menu-item {\n  font-size: 14px !important; }\n\n.mat-menu-panel.pd-menu-container button.mat-menu-item i.fi {\n    font-size: 16px;\n    vertical-align: middle;\n    padding-right: 7px; }\n\na.export-group {\n  background: #e6e9f4;\n  font-weight: 400;\n  padding: 0 10px;\n  min-width: 80px;\n  line-height: 32px; }\n\n.sample-color {\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  vertical-align: middle; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/public-dashboard/public-dashboard.component.scss
// module id = ../../../../../src/app/public-dashboard/public-dashboard.component.scss
// module chunks = main